<template>
  <section class="keyboard container">
    <key
      v-for="letter in letters"
      class="letter"
      :key="letter"
      :letter="letter"
      :dense="dense"
      :ref="language + '_keyboard_keys'"
      :active="active"
      @keypress="keypress"
    />
  </section>
</template>

<script>
import Key from "@/components/keyboard/Key.vue";

export default {
  components: {
    Key
  },
  props: {
    language: String,
    active: Boolean,
    dense: Boolean
  },
  computed: {
    letters() {
      return this.ALPHABET[this.language];
    }
  },
  data() {
    return {
      ALPHABET: {
        GR: [" ", "  ", "Ε", "Ρ", "Τ", "Υ", "Θ", "Ι", "Ο", "Π", "Α", "Σ", "Δ", "Φ", "Γ", "Η", "Ξ", "Κ", "Λ", "Ζ", "Χ", "Ψ", "Ω", "Β", "Ν", "Μ"],
        EN: ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Z", "X", "C", "V", "B", "N", "M"]
      }
    };
  },
  methods: {
    reset() {
      let lang = this.language;
      let key = lang + "_keyboard_keys";

      for (var index in this.$refs[key]) {
        this.$refs[key][index].reset();
      }
    },
    keypress(letter) {
      if (this.active) {
        this.$emit("keypress", letter); // emit to parent
      }
    }
  }
};
</script>

<style scoped lang="scss">
.keyboard {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  &:before,
  &:after {
    content: "";
    width: 100%;
    order: 1;
  }
}
</style>
